import { Typography } from "@/components/atoms";

/** Where an operator stuck on a Veivo check gets help (DEV-2002): RideMinder
 *  staff can check it and let them continue. */
export const SUPPORT_EMAIL = "support@rideminder.com";

/** "{lead} Contact support at support@rideminder.com — {tail}" */
export const ContactSupport = ({ lead, tail, emphasis = false }: { lead: string; tail?: string; emphasis?: boolean }) => (
  <Typography variant="small" className={emphasis ? "text-error" : "text-neutral-dark-gray"} data-testid="contact-support">
    {lead} Contact support at{" "}
    <a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary underline">
      {SUPPORT_EMAIL}
    </a>
    {tail ? ` — ${tail}` : "."}
  </Typography>
);
